import { DELIVERY_ZIPCODE_GET } from '../actionTypes/DeliveryZipcodeActionTypes';

export const getDeliveryZipcode = payload => ({ // eslint-disable-line
    type: DELIVERY_ZIPCODE_GET,
    payload,
});
